import React, { useState } from 'react';
import ReactDOM from 'react-dom';

const MergeDialog = ({ documents, onMerge, onClose }) => {
  const [targetId, setTargetId] = useState(documents[0]?.id);
  const [separator, setSeparator] = useState('\n\n---\n\n');

  const handleMerge = () => {
    const ids = documents.map(d => d.id);
    onMerge(ids, targetId, separator);
  };

  const separatorOptions = [
    { label: '--- (구분선)', value: '\n\n---\n\n' },
    { label: '빈 줄', value: '\n\n' },
    { label: '없음', value: '\n' },
  ];

  return ReactDOM.createPortal(
    <div className="bear-dialog-overlay" onClick={onClose}>
      <div className="bear-dialog" onClick={e => e.stopPropagation()}>
        <h3 className="bear-dialog-title">{documents.length}개 노트 합치기</h3>

        <div className="bear-dialog-body">
          <label className="bear-dialog-label">합치기 순서:</label>
          <div className="bear-dialog-list">
            {documents.map((doc, i) => (
              <div key={doc.id} className="bear-dialog-list-item">
                <span className="bear-dialog-list-num">{i + 1}.</span>
                <span className="bear-dialog-list-title">{doc.title || '제목 없음'}</span>
              </div>
            ))}
          </div>

          <label className="bear-dialog-label">대상 노트:</label>
          <select
            className="bear-dialog-select"
            value={targetId}
            onChange={e => setTargetId(Number(e.target.value))}
          >
            {documents.map(doc => (
              <option key={doc.id} value={doc.id}>
                {doc.title || '제목 없음'}
              </option>
            ))}
          </select>

          <label className="bear-dialog-label">구분자:</label>
          <select
            className="bear-dialog-select"
            value={separator}
            onChange={e => setSeparator(e.target.value)}
          >
            {separatorOptions.map(opt => (
              <option key={opt.label} value={opt.value}>{opt.label}</option>
            ))}
          </select>

          <p className="bear-dialog-warn">
            나머지 노트는 휴지통으로 이동됩니다. 합쳐진 내용은 대상 노트에 추가됩니다.
          </p>
        </div>

        <div className="bear-dialog-actions">
          <button className="bear-dialog-btn cancel" onClick={onClose}>취소</button>
          <button className="bear-dialog-btn primary" onClick={handleMerge}>합치기</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default MergeDialog;
